import { localTime } from '@helpers';

interface UseBatchTimelineActionsParams {
  productionBatchStartDate: string | null;
  setProductionBatchStartDateForDisplay: (date: string | null) => void;
  setProductionBatchEndDateForDisplay: (date: string | null) => void;
  setProductionBatchEndDate: (date: string | null) => void;
  selectRange: (params: { start: string; end: string }) => Promise<void>;
}

export const useBatchTimelineActions = ({
  productionBatchStartDate,
  setProductionBatchStartDateForDisplay,
  setProductionBatchEndDateForDisplay,
  setProductionBatchEndDate,
  selectRange,
}: UseBatchTimelineActionsParams) => {
  const handleSelectRange = async ({ start, end }: { start: string; end: string }) => {
    setProductionBatchStartDateForDisplay(localTime(start).format());
    setProductionBatchEndDateForDisplay(localTime(end).format());
    await selectRange({ start, end });
  };

  const zoomReset = () => {
    const now = localTime().format();
    setProductionBatchStartDateForDisplay(productionBatchStartDate);
    setProductionBatchEndDate(now);
    setProductionBatchEndDateForDisplay(now);
  };

  return { handleSelectRange, zoomReset };
};
